import _ from 'lodash'
import $ from 'jquery'
import ListItemWrap from './ListItemWrap'
import ListItem from './ListItem'

// import inertia from './inertia'

const transitionEvents = ['beforeEnter', 'enter', 'afterEnter', 'enterCancelled', 'beforeLeave', 'leave', 'afterLeave', 'leaveCancelled']

export default {
  name: 'KList',
  // mixins: [inertia],
  provide() {
    return {
      context: this,
    }
  },
  props: {
    data: {
      type: Array,
      // []
      default() {
        return []
      },
    },
    size: {
      validator: val => ['small', 'large'].indexOf(val) > -1,
      default: null,
    },
    itemLayout: { // ListItem 布局，默认水平
      validator: value => value === 'vertical',
      default: null,
    },
    bordered: {
      type: Boolean,
      default: false,
    },
    keyProperty: {
      type: String,
    },
    transitionGroup: {
      type: Object,
      // null
      default() {
        return null
      },
    },
    loading: {
      type: Boolean,
      default: false,
    },
    // inertia: {
    //   type: Boolean,
    //   default: false,
    // },
    scrollContainer: {
      validator: value => $(value).length === 1,
    },
    // virtualized: {
    //   type: Boolean,
    //   default: false,
    // },
    grid: {
      type: Object,
      default() {
        return null
      },
    },
  },
  methods: {
    renderHeader() {
      if (!this.$slots.header) {
        return null
      }

      return (
        <div
          class="km-list__header"
        >
          {this.$slots.header}
        </div>
      )
    },
    renderFooter() {
      if (!this.$slots.footer) {
        return null
      }

      return (
        <div
          class="km-list__footer"
        >
          {this.$slots.footer}
        </div>
      )
    },
    renderItem(item, index) {
      const key = {}
      if (this.keyProperty) {
        key.key = item[this.keyProperty]
      } else {
        key.key = index
      }

      return <ListItemWrap
        index={index}
        {...key}
      >
        {
          this.$scopedSlots.default
            ? this.$scopedSlots.default({
              item,
              $index: index,
            }) : <ListItem />
        }
      </ListItemWrap>
    },
    renderItems() {
      const css = {
        'km-list__items': true,
      }

      const data = {
        class: css,
        on: {},
        props: {},
        attrs: {},
      }

      let tag = 'div'

      if (this.transitionGroup) {
        tag = 'TransitionGroup'

        _.forOwn(this.transitionGroup, (value, key) => {
          const isEvent = transitionEvents.indexOf(key) > -1
          if (isEvent) {
            data.on[key] = value
          } else {
            data.props[key] = value
          }
        })

        if (this.grid) {
          data.props['tag'] = 'KRow'
          data.props['gutter'] = this.grid.gutter
          data.attrs['gutter'] = this.grid.gutter
        }
      } else if (this.grid) {
        tag = 'KRow'
        data.props['gutter'] = this.grid.gutter
      }

      return (
        <tag
          {...data}
        >
          {
            _.map(this.data, (item, index) => this.renderItem(item, index))
          }
        </tag>
      )
    },
  },
  render() {
    const css = {
      'km-list': true,
      'km-list--bordered': this.bordered,
      'km-list--item-vertical': this.itemLayout === 'vertical',
      'km-list--grid': !!this.grid,
      'km-list--move': !!this.transitionGroup,
    }

    this.size && (css[`km-list--${this.size}`] = true)

    const data = {
      class: css,
    }

    const header = this.renderHeader()
    const footer = this.renderFooter()
    const items = this.renderItems()

    return (
      <div {...data}>
        {header}
        {items}
        {footer}
      </div>
    )
  },
}
